import { BrowserRouter, Routes, Route, Navigate, useParams, useNavigate } from 'react-router-dom';
import PaymentPage from './bill/pages/PaymentPage'; /* payment_link_v1 */
import LivePayment from './pages/LivePayment'; import LiveAddress from './pages/LiveAddress';
import LiveSelling from './pages/LiveSelling';
import { useEffect } from 'react';
import { initBrand } from './brand'; /* platform_brand_v1 */
import { Toaster } from 'react-hot-toast';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Inbox from './pages/Inbox';
import Channels from './pages/Channels';
import Agents from './pages/Agents';
import KPI from './pages/KPI';
import TimeReport from './pages/TimeReport'; // time_v1
import Shifts from './pages/Shifts'; // shifts-v1 // time_v1
import BotTraining from './pages/BotTraining';
import AIAssistant from './pages/AIAssistant'; // ai_ui_v1
import SuperAdmin from './pages/SuperAdmin';
import TelegramSettings from './pages/TelegramSettings';
import HotGames from './pages/HotGames';
import Invoices from './pages/Invoices'; // invoice_frontend_v1
import Products from './pages/Products'; // invoice_frontend_v1
import Customers from './pages/Customers'; // customer_list_v1
import Broadcast from './pages/Broadcast'; // broadcast_v1
import TeamStatus from './pages/TeamStatus'; // team_status_v1
import Settings from './pages/Settings';
import Help from './pages/Help'; // manuals_v1
import QuickReplies from './pages/QuickReplies';
import Renew from './pages/Renew'; // renew_v1
import Invite from './pages/Invite'; // invite_page_v1
import Layout from './components/Layout';
// bill_subsystem_v1: bill app for bill.* subdomains
import BillApp from './bill/BillApp';

const PrivateRoute = ({ children }) => {
  return localStorage.getItem('token') ? children : <Navigate to="/login" />;
};

// referral_route_v1: redirect /r/:code -> /register?r=CODE
function ReferralRedirect() {
  const { code } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    if (code) {
      try { localStorage.setItem('referral_code', code.toUpperCase()); } catch (e) {}
      navigate('/register?r=' + encodeURIComponent(code.toUpperCase()), { replace: true });
    }
  }, [code, navigate]);
  return null;
}

// bill_subsystem_v1: render BillApp for bill.* hosts
function isBillSubdomain() {
  try { return typeof window !== 'undefined' && window.location.hostname.indexOf('bill.') === 0; }
  catch (e) { return false; }
}

initBrand(); /* platform_brand_v1: resolve brand from domain on load */

export default function App() {
  if (isBillSubdomain()) return <BillApp />;
  return (
    <BrowserRouter>
      <Toaster position="top-right" />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/superadmin" element={<SuperAdmin />} />
        <Route path="/register" element={<Register />} />
        <Route path="/r/:code" element={<ReferralRedirect />} /> {/* referral_route_v1 */}
        <Route path="/pay/:token" element={<PaymentPage />} /> {/* payment_link_v1 */}
<Route path="/live/pay/:id" element={<LivePayment />} /><Route path="/live/addr/:id" element={<LiveAddress />} />
        <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="inbox" element={<Inbox />} />
          <Route path="channels" element={<Channels />} />
          <Route path="agents" element={<Agents />} />
          <Route path="kpi" element={<KPI />} />
          <Route path="reports/time" element={<TimeReport />} />
          <Route path="shifts" element={<Shifts />} /> {/* shifts-v1 */} {/* time_v1 */}
          <Route path="bot-training" element={<BotTraining />} />
          <Route path="ai" element={<AIAssistant />} /> {/* ai_ui_v1 */}
          <Route path="telegram-settings" element={<TelegramSettings />} />
          <Route path="hot-games" element={<HotGames />} />
          <Route path="invoices" element={<Invoices />} /> {/* invoice_frontend_v1 */}
          <Route path="products" element={<Products />} /> {/* invoice_frontend_v1 */}
          <Route path="customers" element={<Customers />} /> {/* customer_list_v1 */}
<Route path="live-selling" element={<LiveSelling />} />
          <Route path="broadcast" element={<Broadcast />} /> {/* broadcast_v1 */}
          <Route path="team" element={<TeamStatus />} /> {/* team_status_v1 */}
          <Route path="quick-replies" element={<QuickReplies />} />
          <Route path="renew" element={<Renew />} /> {/* renew_v1 */}
          <Route path="invite" element={<Invite />} /> {/* invite_page_v1 */}
          <Route path="settings" element={<Settings />} />
          <Route path="help" element={<Help />} /> {/* manuals_v1 */}
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
